import { ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS } from "../../../constants/entryData/dealTypeAndStatus";

export const DEAL_TYPE_SHELL_KEYS = {
  dealName: ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealName,
  dealStatus: ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealStatus,
  dealType: ENTRY_DATA_DEAL_TYPE_AND_STATUS_KEYS.dealType,
} as const;
